module.exports = __webpack_public_path__ + "XPOicon.588e364eca790a9ac2c8.woff";


//////////////////
// WEBPACK FOOTER
// /ng-app/node_modules/@xpo/common/includes/assets/xpo-icon/fonts/XPOicon.woff?1q9m9g
// module id = ../../../../@xpo/common/includes/assets/xpo-icon/fonts/XPOicon.woff?1q9m9g
// module chunks = styles